import * as React from "react"

const CONFIG_TABLE_RESPONSE: Array<ColumnConfigType> = [
    {
        keystone: "Ordem",
        label: "#",
    },
    {
        keystone: "NomeCategoria",
        label: "Categoria",
    },
    {
        keystone: "Subenunciado",
        label: "Exercício",
        formatter: (Subenunciado: string) => <h4 dangerouslySetInnerHTML={{ __html: Subenunciado }} />
    },
    {
        keystone: "Resultado",
        label: "Resultado",
        formatter: (Resultado: string) => Resultado
            ? <div className="material-icons right-answer">check_circle_outline</div>
            : <div className="material-icons wrong-answer">highlight_off</div>
    },
]


export default CONFIG_TABLE_RESPONSE